/*# sourceMappingURL=electricity-details.component-3UUZQXFU.css.map */
